module.exports = __webpack_public_path__ + "r-v3/img/mobile_premium_feature_004.9656ef50.jpg";